import React, { useState, useCallback, useEffect } from "react";
import { ToastMessage, ToastContainer } from "../../Styles/Toast/Toast";
import { sanitiseString, concatStringFromClassesArrayList } from "../../Utils";
import { SelectedIcon } from "../../Icons";

export interface Props {
  id: string;
  dataTestId: string;
  messages: {
    id: string;
    text: string;
    assistiveTextPrefix?: string;
    assistiveTextSuffix?: string;
    classes?: string;
    duration?: number;
    ariaLabel?: string;
  }[];
}

export const Toast = (props: Props) => {
  const [visibleStates, setVisibleStates] = useState<Map<string, boolean>>(
    new Map(props.messages.map((message) => [message.id, true]))
  );

  const sanitisedDataTestId = sanitiseString(props.dataTestId);
  const toastContainerDataTestId = `${sanitisedDataTestId}-alert-container`;

  const hideToast = useCallback((id: string) => {
    setVisibleStates((prevVisibleStates) => {
      const newVisibleStates = new Map([...prevVisibleStates]);
      newVisibleStates.set(id, false);
      return newVisibleStates;
    });
  }, []);

  useEffect(() => {
    const newVisibleStates = new Map(
      props.messages.map((message) => [message.id, true])
    );

    setVisibleStates((prev) => {
      return new Map([...newVisibleStates, ...prev]);
    });

    const timers = props.messages?.map((message, index) => {
      return setTimeout(
        () => {
          hideToast(message.id);
        },
        (message.duration || 1000) + index * 1000
      );
    });

    return () => {
      timers?.forEach((timer) => {
        clearTimeout(timer);
      });
    };
  }, [hideToast, props, props.messages]);

  return (
    <ToastContainer data-testid={toastContainerDataTestId}>
      {props.messages?.map((message, index) => {
        const messageClassList = {
          defaultClass: "ons-u-mt-xs",
          optionalClasses: [message.classes ? message.classes : ""],
        };

        const messageClassName =
          concatStringFromClassesArrayList(messageClassList);

        return (
          visibleStates.get(message.id) && (
            <ToastMessage
              key={index}
              id={sanitiseString(message.id)}
              data-testid={`${sanitisedDataTestId}-${index}-alert-message`}
              className={messageClassName}
              role="alert"
            >
              <div>
                {message.assistiveTextPrefix && (
                  <span className="ons-u-vh">
                    {message.assistiveTextPrefix + " "}{" "}
                    {/* + " " this was intentionaly done this way over template literals {`${message.assistiveTextPrefix} `} to ensure that the space 
                    is not lost by either editior config changes or prettier changes or mistaken as a space typo */}
                  </span>
                )}
                {message.text}
                {message.assistiveTextSuffix && (
                  <span className="ons-u-vh">
                    {" " + message.assistiveTextSuffix}
                    {/* + " " this was intentionaly done this way over template literals {` ${message.assistiveTextSuffix}`}to ensure that the space 
                    is not lost by either editior config changes or prettier changes or mistaken as a space typo */}
                  </span>
                )}
              </div>
              <div
                onClick={() => hideToast(message.id)}
                aria-label={message.ariaLabel || "Close message"}
                data-testid={`${props.dataTestId}-alert-message-${index}-close`}
                role="button"
              >
                <SelectedIcon iconType="Close" />
              </div>
            </ToastMessage>
          )
        );
      })}
    </ToastContainer>
  );
};
